import React from 'react';
import {
  Container, Grid,
} from '@material-ui/core';
import './no-catalogues.scss';
import { noCataloguesProps } from './no-catalogues-props';

/**
 * Simple container to show copy when there is no catalogues returned.
 * @param props
 */
export const NoCatalogues: React.FC<noCataloguesProps> = (props) => (
  <div className="sg-no-catalogues">
    <Container>
      <Grid container item xs={12}>
        <div className="sg-no-catalogues__content">
          <span className="text--bold">{props.mainMessage}</span>
          <span>{props.description}</span>
        </div>
      </Grid>
    </Container>
  </div>
);
